import React from 'react';

const CGUPage = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="bg-white shadow sm:rounded-lg overflow-hidden">
        <div className="px-4 py-5 sm:px-6">
          <h1 className="text-2xl font-bold text-gray-900">Conditions Générales d'Utilisation</h1>
        </div>
        <div className="px-4 py-5 sm:p-6 prose max-w-none">
          <h2>1. Objet</h2>
          <p>
            Les présentes Conditions Générales d'Utilisation (CGU) régissent l'utilisation du service NoStress Exams,
            une plateforme en ligne permettant aux étudiants de créer des fiches de révision, des quiz et des
            flashcards à l'aide de l'intelligence artificielle.
          </p>

          <h2>2. Description du service</h2>
          <p>
            NoStress Exams propose les fonctionnalités suivantes :
          </p>
          <ul>
            <li>Création de fiches de révision personnalisées</li>
            <li>Génération de quiz interactifs</li>
            <li>Création de flashcards</li>
            <li>Partage de contenus entre utilisateurs</li>
          </ul>

          <h2>3. Inscription et compte utilisateur</h2>
          <p>
            L'utilisation du service NoStress Exams nécessite la création d'un compte utilisateur. L'utilisateur s'engage
            à fournir des informations exactes et à maintenir ces informations à jour. En s'inscrivant, l'utilisateur
            reconnait avoir pris connaissance et accepter les Conditions Générales d'Utilisation et la Politique de
            confidentialité.
          </p>

          <h2>4. Propriété intellectuelle</h2>
          <p>
            Les contenus générés par les utilisateurs restent leur propriété. En partageant du contenu,
            l'utilisateur accorde à NoStress Exams une licence non exclusive d'utilisation.
          </p>

          <h2>5. Protection des données personnelles</h2>
          <p>
            NoStress Exams s'engage à protéger les données personnelles des utilisateurs conformément au RGPD
            et à la législation applicable.
          </p>

          <h2>6. Responsabilités</h2>
          <p>
            L'utilisateur est responsable de l'utilisation qu'il fait du service et des contenus qu'il partage.
            NoStress Exams ne peut être tenu responsable des contenus générés par les utilisateurs. Il appartient
            à l'utilisateur de s'assurer de la complétude et de l'exactitude de la fiche de révision, qui ne
            saurait se substituer aux cours suivis par l'utilisateur. NoStress Exams ne peut être tenu responsable
            lorsque des informations inexactes sont présentes sur les documents transmis lors de la demande de
            création de fiche.
          </p>

          <h2>7. Modification des CGU</h2>
          <p>
            NoStress Exams se réserve le droit de modifier les présentes CGU à tout moment. Les utilisateurs
            seront informés des modifications importantes.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CGUPage;